const ExternalLink = ({ item }) => (
	<a href={item.url} target="_blank" rel="noreferrer">
		{item.text}
	</a>
);

export default ExternalLink;
